<div class="order-details-skeleton" aria-hidden="true">
  @if (!onlyRows) {
    <div class="d-flex flex-row justify-content-between align-items-center mb-4 mt-4 placeholder-glow">
      <span class="placeholder rounded" style="width: 280px; height: 40px"></span>
      <span class="placeholder rounded" style="width: 84px; height: 36px"></span>
    </div>

    <div class="skeleton-accordion-header d-flex justify-content-between align-items-center placeholder-glow">
      <span class="placeholder col-1"></span>
      <span class="placeholder" style="width: 16px"></span>
    </div>
    <div class="row py-3">
      @for (column of detailColumnArray; track $index) {
        <div class="col-12 col-md-6 placeholder-glow">
          <span class="placeholder mb-3" style="width: 90px; height: 22px"></span>
          @for (detail of detailArray; track $index) {
            <div class="d-flex mb-3">
              <span class="placeholder" style="width: 110px"></span>
              <span class="placeholder ms-5" style="width: 90px"></span>
            </div>
          }
        </div>
      }
    </div>

    <div class="skeleton-accordion-header d-flex justify-content-between align-items-center placeholder-glow mb-4">
      <span class="placeholder col-2"></span>
      <span class="placeholder" style="width: 16px"></span>
    </div>
  }

  <table class="table table-striped">
    <thead>
      <tr class="placeholder-glow">
        <th style="width: 50%"><span class="placeholder" style="width: 90px"></span></th>
        @for (col of columnArray; track $index) {
          <th><span class="placeholder col-8"></span></th>
        }
      </tr>
    </thead>
    <tbody>
      @for (row of rowArray; track $index) {
        <tr class="placeholder-glow">
          <td>
            <div class="d-flex">
              <span class="placeholder rounded flex-shrink-0 me-4" style="width: 64px; height: 64px"></span>
              <div class="d-flex flex-column gap-2 w-100">
                <span class="placeholder" style="width: 110px"></span>
                <span class="placeholder" style="width: 80px"></span>
                <span class="placeholder placeholder-xs" style="width: 60px"></span>
              </div>
            </div>
          </td>
          @for (col of columnArray; track $index) {
            <td><span class="placeholder col-7"></span></td>
          }
        </tr>
      }
    </tbody>
  </table>
</div>
